import * as React from "react";

import { Box, Grid, Stack, Typography } from "@mui/material";

import CustomInput from "../../../../helper-components/input/CustomInput";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { validateRow } from "../../../../helper-functions/validation/objectValidation";
import { addFormToObj, setInsertObjectState, setValue } from "../../../../helper-functions/shared/miscUtils";
import { IS_COOKIE_VALID, COOKIE_VALIDATION } from "../../../../helper-functions/validation/cookieValidation";

import { getLanguage } from "../../../../config/language/language";
import { COOKIE_REQUEST_OBJECT, COOKIE_TYPES } from "../../../../config/constants/Constants";

/**
 * A form to update a cookie.
 */
export default function CookieAddForm(props) {
    // Because modals don't re-render if the props' state changes, use a callback.
    const { callback, row: existingRow = {} } = props;

    const object = COOKIE_REQUEST_OBJECT;
    const validation = COOKIE_VALIDATION;
    const isValid = IS_COOKIE_VALID;

    const [row, setRow] = React.useState(addFormToObj(JSON.parse(JSON.stringify(object))));

    // Initialize the temporary row object with existing values.
    React.useEffect(() => {
        const newRow = {
            ...row,
            ...existingRow,

            form: {
                ...row.form,
                ...existingRow.form,
                saved: false // Required to allow editing input fields.
            }
        };

        setInsertObjectState(setRow, newRow);
    }, []);

    /**
     * Executed when typing something into an input field.
     */
    const onChange = (obj, key, value) => {
        const newCookie = JSON.parse(JSON.stringify(row));
        setValue(newCookie, key, value);

        validateRow(obj, validation, newCookie);
        setInsertObjectState(setRow, newCookie);
    };

    const handleClick = () => {
        if (!isValid(row)) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_FORM_INVALID, color: "error" });
            return;
        }

        const options = { row };
        callback(true, options);
    };

    const placeholder = `# Netscape HTTP Cookie File
# http://curl.haxx.se/rfc/cookie_spec.html
# This file was generated by Cookie-Editor
...`;

    return (
        <Box className="box">
            <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                    <CustomInput name="type" row={row} onChange={onChange} label="Type" select={COOKIE_TYPES} />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Stack direction="row" justifyContent="center" alignItems="center">
                        <CustomInput name="manual_use" row={row} onChange={onChange} checkbox />
                        <Typography variant="body2" color="textSecondary">
                            {"Manually set to be used?"}
                        </Typography>
                    </Stack>
                </Grid>

                <Grid item xs={12}>
                    <CustomInput
                        name="text"
                        row={row}
                        onChange={onChange}
                        label="Copy & paste cookies in Netscape format here"
                        multiline
                        minRows={4}
                        maxRows={4}
                        placeholder={placeholder}
                    />
                </Grid>

                <Grid item xs={12}>
                    <CustomInput name="note" row={row} onChange={onChange} label="Note" multiline minRows={2} maxRows={5} />
                </Grid>
            </Grid>

            <CustomButton {...props} title={"Save cookie"} onClick={handleClick} className="button" fullWidth />
        </Box>
    );
}
